import { useMemo } from 'react';

import { formatNumberAsCurrency } from '@work4all/utils';

import { createFooterCell } from './create-footer-cell';

export type ICurrencyCellProps = {
  value: string | number;
  column?: {
    id: string;
    cellParams: {
      currencyField?: string;
      courseField?: string;
      hideUnit?: boolean;
    };
  };
  row?: {
    original: unknown;
  };
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  hideUnit?: boolean;
  className?: string;
  onEdit?: () => void;
};

function index(obj, i) {
  return obj?.[i];
}

export const CurrencyCell = (props: ICurrencyCellProps) => {
  const {
    value,
    column,
    row,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    hideUnit = false,
    className = '',
  } = props;

  const cellParams = column?.cellParams;
  const rowData = row?.original;

  let currency = '€';
  if (rowData && cellParams?.currencyField) {
    const accessorKey = cellParams?.currencyField;
    const key = accessorKey?.split('.');
    const accessor = key.splice(1);
    const valueObj = rowData[key[0]] as unknown[];
    currency = accessor.reduce(index, valueObj);
  }

  let course = 1;
  if (rowData && cellParams?.courseField) {
    const accessorKey = cellParams?.courseField;
    const key = accessorKey?.split('.');
    const accessor = key.splice(1);
    const valueObj = rowData[key[0]] as unknown[];
    course = accessor.reduce(index, valueObj);
  }

  if (currency === 'EUR') currency = '€';
  if (currency === 'USD') currency = '$';

  const displayValue = useMemo(() => {
    if ((typeof value === 'string' && value === '0') || value === 0) {
      return '';
    } else {
      return formatNumberAsCurrency(
        (typeof value === 'string' ? parseInt(value, 10) : value) * course,
        {
          minimum: minimumFractionDigits,
          maximum: maximumFractionDigits,
        }
      );
    }
  }, [course, maximumFractionDigits, minimumFractionDigits, value]);

  return (
    <div
      style={{ textAlign: 'right', paddingRight: '.5rem' }}
      className={className}
      onClick={props.onEdit}
    >
      {displayValue}
      {displayValue !== ''
        ? !hideUnit && !cellParams?.hideUnit && <>&nbsp;{currency}</>
        : null}
    </div>
  );
};

export const CurrencyFooterCell = createFooterCell(CurrencyCell, 0);
